import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from './Button';

const BaseForm = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  children,
  primaryColor = '#0052cc',
  icon,
  actions,
  submitButtonText = 'Salvar',
  cancelButtonText = 'Cancelar',
  isValid = true,
  className = '',
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  const renderActions = () => {
    if (actions) return actions;

    return (
      <>
        <Button
          type="button"
          onClick={onClose}
          variant="secondary"
          className="w-full"
        >
          {cancelButtonText}
        </Button>
        <Button
          type="submit"
          variant="primary"
          disabled={!isValid}
          className="w-full"
          style={{ backgroundColor: isValid ? primaryColor : undefined }}
        >
          {submitButtonText}
        </Button>
      </>
    );
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          onClick={onClose}
          className="bg-slate-900/20 backdrop-blur fixed inset-0 z-50 grid place-items-center overflow-y-scroll cursor-pointer p-4"
        >
          <motion.div
            key="modal-content"
            className={`bg-white rounded-2xl w-full max-w-2xl shadow-xl relative z-10 cursor-default max-h-[90vh] overflow-y-auto ${className}`}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{
              duration: 0.35,
              ease: 'easeOut',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-6 flex items-center gap-4 relative z-10">
              {icon && <span style={{ color: primaryColor }}>{icon}</span>}
              <h2 className="text-lg font-medium">{title}</h2>
              <motion.button
                onClick={onClose}
                className="ml-auto text-gray-400 hover:text-gray-600"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </motion.button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="px-6 pb-6 space-y-4 relative z-10">{children}</div>

              <motion.div
                className="p-4 flex justify-end space-x-2 relative z-10"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.1, duration: 0.25 }}
              >
                {renderActions()}
              </motion.div>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BaseForm;
